// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../assets/fonts/Poppins-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../assets/fonts/Montserrat-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../assets/fonts/Poppins-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../../assets/fonts/Montserrat-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../../assets/fonts/Poppins-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../../assets/fonts/Montserrat-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../../assets/fonts/Gilroy-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../../../assets/fonts/Gilroy-ExtraBold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../../../assets/fonts/Gilroy-Medium.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ModalTopUp_primary-surface__AnvIX {
  background: #5d2de1;
  box-shadow: 0px 0px 1px rgba(235, 79, 37, 0.24), 0px 2px 4px -1px rgba(27, 10, 82, 0.12), 0px 8px 8px -4px rgba(235, 79, 37, 0.12);
  border-radius: 12px;
}

.ModalTopUp_primary-bg__Jpvrr {
  background: #5d2de1;
  border-radius: 12px;
}

.ModalTopUp_secondary-surface__bgbYF {
  background: linear-gradient(135deg, #ffffff 0%, #fafbfc 51.82%, #f5f7fa 100%);
  box-shadow: 0px 1px 1px rgba(9, 13, 20, 0.06), -4px -4px 8px rgba(255, 255, 255, 0.4), 8px 8px 24px rgba(9, 13, 20, 0.06);
}

.ModalTopUp_faded-surface__1Cri4 {
  background: rgba(93, 45, 225, 0.06);
  border-radius: 12px;
}

.ModalTopUp_header-surface__Pwbnj {
  background: #5d2de1;
  box-shadow: 0px 0px 1px rgba(235, 79, 37, 0.24), 0px 2px 4px -1px rgba(27, 10, 82, 0.12), 0px 8px 8px -4px rgba(235, 79, 37, 0.12);
  border-radius: 12px;
}

.ModalTopUp_card-surface__VT7Ka {
  background: linear-gradient(135deg, #ffffff 0%, #fafbfc 51.82%, #f5f7fa 100%);
  box-shadow: 0px 1px 1px rgba(9, 13, 20, 0.06), -4px -4px 8px rgba(255, 255, 255, 0.4), 8px 8px 24px rgba(9, 13, 20, 0.06);
}

.ModalTopUp_dropdown-surface__xjeae {
  background: linear-gradient(135deg, #ffffff 0%, #fafbfc 51.82%, #f5f7fa 100%);
  box-shadow: 0px 1px 1px rgba(9, 13, 20, 0.06), -4px -4px 8px rgba(255, 255, 255, 0.4), 8px 8px 24px rgba(9, 13, 20, 0.06);
  border-radius: 12px;
}

.ModalTopUp_faded-1-surface__gmSkt {
  background: rgba(93, 45, 225, 0.06);
  mix-blend-mode: normal;
  border-radius: 12px;
}

.ModalTopUp_faded-2-surface__VlTmg {
  background: rgba(60, 53, 210, 0.12);
  mix-blend-mode: normal;
  border-radius: 12px;
}

@font-face {
  font-family: "bold-Poppins";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
@font-face {
  font-family: "bold-Montserrat";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
@font-face {
  font-family: "semi-Poppins";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}
@font-face {
  font-family: "semi-Montserrat";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}
@font-face {
  font-family: "med-Poppins";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}
@font-face {
  font-family: "med-Montserrat";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}
@font-face {
  font-family: "bold-gilory";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}
@font-face {
  font-family: "extra-gilory";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}
@font-face {
  font-family: "semi-gilory";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}
@font-face {
  font-family: "med-gilory";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}
.ModalTopUp_sectionTitle__3H2lj {
  color: rgba(20, 16, 41, 0.8);
  font-family: "bold-Poppins";
  font-weight: 700;
  font-size: 36px;
  line-height: 36px;
  position: relative;
}

.ModalTopUp_lightSectionTitle__By06o {
  color: #ffffff;
  font-family: "bold-Poppins";
  font-weight: 700;
  font-size: 36px;
  line-height: 36px;
}

.ModalTopUp_cardTitle__EGpf1 {
  color: rgba(20, 16, 41, 0.8);
  font-family: "semi-Montserrat";
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  display: block;
}

.ModalTopUp_cardSubTitle__V-bPS {
  color: rgba(20, 16, 41, 0.8);
  font-family: "med-Montserrat";
  font-weight: 500;
  font-size: 13px;
  line-height: 16px;
  display: block;
}

@font-face {
  font-family: "bold-Poppins";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
@font-face {
  font-family: "bold-Montserrat";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
@font-face {
  font-family: "semi-Poppins";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}
@font-face {
  font-family: "semi-Montserrat";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}
@font-face {
  font-family: "med-Poppins";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}
@font-face {
  font-family: "med-Montserrat";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}
@font-face {
  font-family: "bold-gilory";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}
@font-face {
  font-family: "extra-gilory";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}
@font-face {
  font-family: "semi-gilory";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}
@font-face {
  font-family: "med-gilory";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}
.ModalTopUp_modal__YzSCF {
  display: flex;
  flex-direction: column;
  gap: 16px;
  height: 35%;
  width: 20%;
  max-width: 990px;
}
.ModalTopUp_modal__YzSCF .ModalTopUp_titleContainer__ZB8mx {
  background-color: transparent;
  display: flex;
  align-items: center;
  gap: 16px;
}
.ModalTopUp_modal__YzSCF .ModalTopUp_header__K-LkB {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.ModalTopUp_modal__YzSCF .ModalTopUp_header__K-LkB button {
  position: absolute;
  bottom: 0;
}
.ModalTopUp_modal__YzSCF .ModalTopUp_toggleContainer__yOL3w {
  display: flex;
  width: 100%;
  border-bottom: 1px solid rgba(20, 16, 41, 0.12);
  border-radius: 1px 1px 0px 0px;
  position: relative;
  margin-bottom: 8px;
}
.ModalTopUp_modal__YzSCF .ModalTopUp_active__I2svQ {
  font-weight: 600;
  font-family: "semi-Montserrat";
}
.ModalTopUp_modal__YzSCF .ModalTopUp_notActive__dQzfv {
  font-weight: 500;
  font-family: "med-Montserrat";
}
.ModalTopUp_modal__YzSCF .ModalTopUp_activeBorder__kG6pO {
  height: 2px;
  background-color: #5d2de1;
  position: absolute;
  bottom: -1px;
  transition: all 0.2s;
}
.ModalTopUp_modal__YzSCF .ModalTopUp_container__66\\+Lm {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 16px;
  background-color: var(--bg-color);
}
.ModalTopUp_modal__YzSCF .ModalTopUp_card__TBgho {
  background: rgba(235, 239, 245, 0.6);
  border-radius: 24px;
  padding: 20px 24px 24px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
}
.ModalTopUp_modal__YzSCF .ModalTopUp_card__TBgho h3 {
  color: rgba(20, 16, 41, 0.8);
  font-weight: 600;
  font-size: 18px;
  line-height: 24px;
  font-family: "semi-Montserrat";
}
.ModalTopUp_modal__YzSCF .ModalTopUp_card__TBgho form {
  display: flex;
  flex-direction: column;
  gap: 24px;
}
.ModalTopUp_modal__YzSCF .ModalTopUp_card__TBgho .ModalTopUp_rowForm__WCXBw {
  display: flex;
  flex-direction: row;
  gap: 16px;
}
.ModalTopUp_modal__YzSCF .ModalTopUp_card__TBgho .ModalTopUp_rowForm__WCXBw .ModalTopUp_colContainer__VJ7Jl {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 416px;
  gap: 24px;
}
@media (max-width: 650px) {
  .ModalTopUp_modal__YzSCF .ModalTopUp_card__TBgho .ModalTopUp_rowForm__WCXBw {
    flex-direction: column;
  }
}
.ModalTopUp_modal__YzSCF .ModalTopUp_card__TBgho .ModalTopUp_inpContainer__zuHGU {
  height: 48px;
  width: 100%;
}
.ModalTopUp_modal__YzSCF .ModalTopUp_halfWidth__VtOev {
  max-width: 440px;
}
.ModalTopUp_modal__YzSCF .ModalTopUp_fullWidth__IOvzJ {
  max-width: 100%;
}
.ModalTopUp_modal__YzSCF .ModalTopUp_switchContainer__Mvr-e {
  background: rgba(20, 16, 41, 0.03);
  border-radius: 12px;
  padding: 14px 12px;
}
.ModalTopUp_modal__YzSCF .ModalTopUp_viewBtn__tsc3\\+ {
  position: absolute;
  right: 12px;
  top: 12px;
  z-index: 3;
}
.ModalTopUp_modal__YzSCF .ModalTopUp_infoContainer__rGDJG {
  background: rgba(20, 16, 41, 0.03);
  border-radius: 12px;
  padding: 8px 12px;
}
.ModalTopUp_modal__YzSCF .ModalTopUp_infoContainer__rGDJG span {
  display: block;
}
.ModalTopUp_modal__YzSCF .ModalTopUp_infoContainer__rGDJG .ModalTopUp_key__YJgUD {
  color: rgba(20, 16, 41, 0.8);
  font-weight: 500;
  font-size: 10px;
  line-height: 12px;
  font-family: "med-Montserrat";
}
.ModalTopUp_modal__YzSCF .ModalTopUp_infoContainer__rGDJG .ModalTopUp_value__nnxJ\\+ {
  color: rgba(20, 16, 41, 0.8);
  font-weight: 500;
  font-size: 13px;
  line-height: 16px;
  font-family: "med-Montserrat";
}
.ModalTopUp_modal__YzSCF .ModalTopUp_paymentContainer__SCq5l {
  display: flex;
  justify-content: space-between;
  gap: 24px;
}
.ModalTopUp_modal__YzSCF .ModalTopUp_paymentContainer__SCq5l .ModalTopUp_cardInp__6nrSA {
  width: 100%;
  max-width: 272px;
}
.ModalTopUp_modal__YzSCF .ModalTopUp_paymentContainer__SCq5l .ModalTopUp_expInp__Lp9Wu {
  width: 100%;
  max-width: 96px;
}
.ModalTopUp_modal__YzSCF .ModalTopUp_paymentContainer__SCq5l .ModalTopUp_stateInp__4JDPQ {
  width: 100%;
  max-width: 296px;
}
.ModalTopUp_modal__YzSCF .ModalTopUp_paymentContainer__SCq5l .ModalTopUp_number__XVOKQ {
  font-family: "med-gilory";
}
.ModalTopUp_modal__YzSCF .ModalTopUp_btns__Wm\\+D2 {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 16px;
}
.ModalTopUp_modal__YzSCF .ModalTopUp_btns__Wm\\+D2 button {
  max-width: 188px;
  width: 100%;
}
.ModalTopUp_modal__YzSCF .ModalTopUp_btns__Wm\\+D2 .ModalTopUp_delete__PdlYm {
  background-color: rgba(20, 16, 41, 0.03);
}
.ModalTopUp_modal__YzSCF .ModalTopUp_btns__Wm\\+D2 .ModalTopUp_delete__PdlYm:hover {
  background-color: #141029;
}
.ModalTopUp_modal__YzSCF .ModalTopUp_methodsContainer__6hJl4 {
  display: flex;
  flex-direction: column;
  height: 328px;
  overflow: auto;
  gap: 16px;
}
.ModalTopUp_modal__YzSCF .ModalTopUp_methodContainer__ekFyQ {
  background: rgba(20, 16, 41, 0.03);
  border-radius: 12px;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  cursor: pointer;
}
.ModalTopUp_modal__YzSCF .ModalTopUp_methodContainer__ekFyQ img {
  width: 24px;
}
.ModalTopUp_modal__YzSCF .ModalTopUp_methodContainer__ekFyQ span {
  color: rgba(20, 16, 41, 0.8);
  font-weight: 600;
  font-size: 13px;
  line-height: 16px;
  font-family: "semi-Montserrat";
}
.ModalTopUp_modal__YzSCF .ModalTopUp_activeMethod__5SFsx {
  outline: solid 2px #5d2de1;
  outline-offset: -5px;
}
.ModalTopUp_modal__YzSCF .ModalTopUp_largeTexts__FjxSW button {
  font-size: 12px;
}
.ModalTopUp_modal__YzSCF .ModalTopUp_addNew__8bcPx {
  margin-left: auto;
}
@media (max-width: 650px) {
  .ModalTopUp_modal__YzSCF .ModalTopUp_addNew__8bcPx {
    margin-left: initial;
  }
}
.ModalTopUp_modal__YzSCF .ModalTopUp_walletsContainer__etvXQ {
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
}
.ModalTopUp_modal__YzSCF .ModalTopUp_walletsContainer__etvXQ button {
  background: rgba(20, 16, 41, 0.03);
  border-radius: 12px;
  padding: 10px;
}
.ModalTopUp_modal__YzSCF .ModalTopUp_walletsContainer__etvXQ img {
  width: 36px;
}
.ModalTopUp_modal__YzSCF .ModalTopUp_marginTopBtn__V48iJ {
  margin-top: 88px;
}
@media (max-width: 550px) {
  .ModalTopUp_modal__YzSCF {
    padding: 40px 16px 32px;
  }
  .ModalTopUp_modal__YzSCF .ModalTopUp_titleContainer__ZB8mx h2 {
    font-size: 24px;
    line-height: 28px;
  }
  .ModalTopUp_modal__YzSCF .ModalTopUp_marginTopBtn__V48iJ {
    margin-top: 0;
  }
}

.ModalTopUp_methodsContainer__6hJl4::-webkit-scrollbar {
  width: 12px;
}

.ModalTopUp_methodsContainer__6hJl4::-webkit-scrollbar-thumb {
  border: 4px solid rgba(0, 0, 0, 0);
  background-clip: padding-box;
  border-radius: 9999px;
  background-color: #aaaaaa;
}

.ModalTopUp_popup-surface__x9-Fy {
  position: fixed;
  left: 72%;
  transition: all 0.2s;
  z-index: 10;
  overflow: auto;
  max-height: 87vh;
  max-width: 100%;
  transform: translateX(-50%);
  border-radius: 12px;
}
@media (max-width: 550px) {
  .ModalTopUp_popup-surface__x9-Fy {
    border-radius: 40px 40px 0px 0px;
  }
}

.ModalTopUp_show__oWC-y {
  animation: ModalTopUp_fadeIn__AzNWx 0.3s forwards;
}
@media (max-width: 550px) {
  .ModalTopUp_show__oWC-y {
    animation: ModalTopUp_resposiveFadeIn__qVS6C 0.3s forwards;
  }
}

@keyframes ModalTopUp_fadeIn__AzNWx {
  0% {
    opacity: 0;
    top: 4%;
  }
  50% {
    opacity: 1;
    top: 12%;
  }
  100% {
    top: 10%;
  }
}
@keyframes ModalTopUp_resposiveFadeIn__qVS6C {
  0% {
    opacity: 0;
    bottom: -105%;
  }
  100% {
    opacity: 1;
    bottom: 0;
  }
}
/* width */
.ModalTopUp_popup-surface__x9-Fy::-webkit-scrollbar {
  width: 12px;
}

.ModalTopUp_popup-surface__x9-Fy::-webkit-scrollbar-track {
  margin: 30px 0;
}

.ModalTopUp_popup-surface__x9-Fy::-webkit-scrollbar-thumb {
  border: 4px solid rgba(0, 0, 0, 0);
  background-clip: padding-box;
  border-radius: 9999px;
  background-color: #aaaaaa;
}`, "",{"version":3,"sources":["webpack://./src/assets/stylesheets/shared/_surface.scss","webpack://./src/components/UI/ModalTopUp/ModalTopUp.module.scss","webpack://./src/assets/stylesheets/_variables.scss","webpack://./src/assets/stylesheets/shared/_typography.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,kIAAA;EAGA,mBAAA;ACDF;;ADGA;EACE,mBAAA;EACA,mBAAA;ACAF;;ADEA;EACE,6EAAA;EACA,yHAAA;ACCF;;ADEA;EACE,mCAAA;EACA,mBAAA;ACCF;;ADCA;EACE,mBAAA;EACA,kIAAA;EAGA,mBAAA;ACAF;;ADEA;EACE,6EAAA;EACA,yHAAA;ACCF;;ADEA;EACE,6EAAA;EACA,yHAAA;EAEA,mBAAA;ACAF;;ADOA;EACE,mCAAA;EACA,sBAAA;EACA,mBAAA;ACJF;;ADMA;EACE,mCAAA;EACA,sBAAA;EACA,mBAAA;ACHF;;ACJA;EACE,2BAAA;EACA,4CAAA;ADOF;ACLA;EACE,8BAAA;EACA,4CAAA;ADOF;ACLA;EACE,2BAAA;EACA,4CAAA;ADOF;ACLA;EACE,8BAAA;EACA,4CAAA;ADOF;ACLA;EACE,0BAAA;EACA,4CAAA;ADOF;ACLA;EACE,6BAAA;EACA,4CAAA;ADOF;ACLA;EACE,0BAAA;EACA,4CAAA;ADOF;ACLA;EACE,2BAAA;EACA,4CAAA;ADOF;ACLA;EACE,0BAAA;EACA,4CAAA;ADOF;ACLA;EACE,yBAAA;EACA,4CAAA;ADOF;AEvFA;EACE,4BDCgB;ECAhB,2BDiFuB;EChFvB,gBDoCU;ECnCV,eDoBc;ECnBd,iBD4BgB;EC3BhB,kBAAA;AFyFF;;AEvFA;EACE,cDNY;ECOZ,2BDyEuB;ECxEvB,gBD4BU;EC3BV,eDYc;ECXd,iBDoBgB;ADsElB;;AExFA;EACE,4BDdgB;ECehB,8BDsEsB;ECrEtB,gBDoBS;ECnBT,eAAA;EACA,iBDSe;ECRf,cAAA;AF2FF;;AEzFA;EACE,4BDtBgB;ECuBhB,6BD+DqB;EC9DrB,gBDWW;ECVX,eDVa;ECWb,iBDDe;ECEf,cAAA;AF4FF;;AC/EA;EACE,2BAAA;EACA,4CAAA;ADkFF;AChFA;EACE,8BAAA;EACA,4CAAA;ADkFF;AChFA;EACE,2BAAA;EACA,4CAAA;ADkFF;AChFA;EACE,8BAAA;EACA,4CAAA;ADkFF;AChFA;EACE,0BAAA;EACA,4CAAA;ADkFF;AChFA;EACE,6BAAA;EACA,4CAAA;ADkFF;AChFA;EACE,0BAAA;EACA,4CAAA;ADkFF;AChFA;EACE,2BAAA;EACA,4CAAA;ADkFF;AChFA;EACE,0BAAA;EACA,4CAAA;ADkFF;AChFA;EACE,yBAAA;EACA,4CAAA;ADkFF;AAhKA;EACI,aAAA;EACA,sBAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;EACA,gBAAA;AAkKJ;AAjKI;EACI,6BAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;AAmKR;AAjKI;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;AAmKR;AAjKQ;EACI,kBAAA;EACA,SAAA;AAmKZ;AAhKI;EACI,aAAA;EACA,WAAA;EACA,+CAAA;EACA,8BAAA;EACA,kBAAA;EACA,kBAAA;AAkKR;AAhKI;EACI,gBCIG;EDHH,8BCoDgB;AD8GxB;AAhKI;EACI,gBCDK;EDEL,6BCiDe;ADiHvB;AAhKI;EACI,WAAA;EACA,yBC5CQ;ED6CR,kBAAA;EACA,YAAA;EACA,oBAAA;AAkKR;AAhKI;EACI,aAAA;EACA,8BAAA;EACA,eAAA;EACA,SAAA;EACA,iCAAA;AAkKR;AAhKI;EACI,oCAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,WAAA;AAkKR;AAhKQ;EACI,4BC/DM;EDgEN,gBC5BD;ED6BC,eC/CG;EDgDH,iBCvCK;EDwCL,8BCkBY;ADgJxB;AAhKQ;EACI,aAAA;EACA,sBAAA;EACA,SAAA;AAkKZ;AAhKQ;EACI,aAAA;EACA,mBAAA;EACA,SAAA;AAkKZ;AAjKY;EACI,aAAA;EACA,sBAAA;EACA,WAAA;EACA,gBAAA;EAEA,SAAA;AAkKhB;AAhKY;EAZJ;IAaQ,sBAAA;EAmKd;AACF;AAhKQ;EACI,YAAA;EACA,WAAA;AAkKZ;AA/JI;EACI,gBAAA;AAiKR;AA/JI;EACI,eAAA;AAiKR;AA/JI;EACI,kCAAA;EACA,mBAAA;EACA,kBAAA;AAiKR;AA/JI;EACI,kBAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;AAiKR;AA/JI;EACI,kCAAA;EACA,mBAAA;EACA,iBAAA;AAiKR;AAhKQ;EACI,cAAA;AAkKZ;AAhKQ;EACI,4BCzHM;ED0HN,gBCvFC;EDwFD,eAAA;EACA,iBAAA;EACA,6BCvCW;ADyMvB;AAhKQ;EACI,4BChIM;EDiIN,gBC9FC;ED+FD,eCnHG;EDoHH,iBC1GK;ED2GL,6BC9CW;ADgNvB;AA/JI;EACI,aAAA;EACA,8BAAA;EACA,SAAA;AAiKR;AAhKQ;EACI,WAAA;EACA,gBAAA;AAkKZ;AAhKQ;EACI,WAAA;EACA,eAAA;AAkKZ;AAhKQ;EACI,WAAA;EACA,gBAAA;AAkKZ;AAhKQ;EACI,yBC9Da;ADgOzB;AA/JI;EACI,WAAA;EACA,aAAA;EACA,eAAA;EACA,8BAAA;EACA,SAAA;AAiKR;AAhKQ;EACI,gBAAA;EACA,WAAA;AAkKZ;AAhKQ;EACI,wCAAA;AAkKZ;AAjKY;EACI,yBC1KH;AD6Ub;AA/JI;EACI,aAAA;EACA,sBAAA;EACA,aAAA;EACA,cAAA;EACA,SAAA;AAiKR;AA/JI;EACI,kCAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,aAAA;EACA,eAAA;AAiKR;AAhKQ;EACI,WAAA;AAkKZ;AAhKQ;EACI,4BC/LM;EDgMN,gBC5JD;ED6JC,eClLG;EDmLH,iBCzKK;ED0KL,8BC9GY;ADgRxB;AA/JI;EACI,0BAAA;EACA,oBAAA;AAiKR;AA9JQ;EACI,eAAA;AAgKZ;AA7JI;EACI,iBAAA;AA+JR;AA9JQ;EAFJ;IAGQ,oBAAA;EAiKV;AACF;AA/JI;EACI,aAAA;EACA,SAAA;EACA,eAAA;AAiKR;AAhKQ;EACI,kCAAA;EACA,mBAAA;EACA,aAAA;AAkKZ;AAhKQ;EACI,WAAA;AAkKZ;AA/JI;EACI,gBAAA;AAiKR;AA/JI;EArOJ;IAsOQ,uBAAA;EAkKN;EAjKM;IACI,eCpNG;IDqNH,iBC7MK;EDgXf;EAjKM;IACI,aAAA;EAmKV;AACF;;AAhKA;EACI,WAAA;AAmKJ;;AAhKA;EACI,kCAAA;EACA,4BAAA;EACA,qBAAA;EACA,yBAAA;AAmKJ;;AAhKA;EACI,eAAA;EACA,SAAA;EACA,oBAAA;EACA,WAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,2BAAA;EACA,mBAAA;AAmKJ;AAlKI;EAVJ;IAWQ,gCAAA;EAqKN;AACF;;AAlKA;EACI,iDAAA;AAqKJ;AApKI;EAFJ;IAGQ,0DAAA;EAuKN;AACF;;AApKA;EACI;IACI,UAAA;IACA,OAAA;EAuKN;EArKE;IACI,UAAA;IACA,QAAA;EAuKN;EArKE;IACI,QAAA;EAuKN;AACF;AArKA;EACI;IACI,UAAA;IACA,aAAA;EAuKN;EArKE;IACI,UAAA;IACA,SAAA;EAuKN;AACF;AArKA,UAAA;AACA;EACI,WAAA;AAuKJ;;AArKA;EACI,cAAA;AAwKJ;;AArKA;EACI,kCAAA;EACA,4BAAA;EACA,qBAAA;EACA,yBAAA;AAwKJ","sourcesContent":[".primary-surface {\n  background: #5d2de1;\n  box-shadow: 0px 0px 1px rgba(235, 79, 37, 0.24),\n    0px 2px 4px -1px rgba(27, 10, 82, 0.12),\n    0px 8px 8px -4px rgba(235, 79, 37, 0.12);\n  border-radius: 12px;\n}\n.primary-bg {\n  background: #5d2de1;\n  border-radius: 12px;\n}\n.secondary-surface {\n  background: linear-gradient(135deg, #ffffff 0%, #fafbfc 51.82%, #f5f7fa 100%);\n  box-shadow: 0px 1px 1px rgba(9, 13, 20, 0.06),\n    -4px -4px 8px rgba(255, 255, 255, 0.4), 8px 8px 24px rgba(9, 13, 20, 0.06);\n}\n.faded-surface {\n  background: rgba(93, 45, 225, 0.06);\n  border-radius: 12px;\n}\n.header-surface {\n  background: #5d2de1;\n  box-shadow: 0px 0px 1px rgba(235, 79, 37, 0.24),\n    0px 2px 4px -1px rgba(27, 10, 82, 0.12),\n    0px 8px 8px -4px rgba(235, 79, 37, 0.12);\n  border-radius: 12px;\n}\n.card-surface {\n  background: linear-gradient(135deg, #ffffff 0%, #fafbfc 51.82%, #f5f7fa 100%);\n  box-shadow: 0px 1px 1px rgba(9, 13, 20, 0.06),\n    -4px -4px 8px rgba(255, 255, 255, 0.4), 8px 8px 24px rgba(9, 13, 20, 0.06);\n}\n.dropdown-surface {\n  background: linear-gradient(135deg, #ffffff 0%, #fafbfc 51.82%, #f5f7fa 100%);\n  box-shadow: 0px 1px 1px rgba(9, 13, 20, 0.06),\n    -4px -4px 8px rgba(255, 255, 255, 0.4), 8px 8px 24px rgba(9, 13, 20, 0.06);\n  border-radius: 12px;\n}\n// .popup-surface {\n//   background: linear-gradient(135deg, #ffffff 0%, #fafbfc 51.82%, #f5f7fa 100%);\n//   box-shadow: 0px 1px 1px rgba(9, 13, 20, 0.06),\n//     -4px -4px 8px rgba(255, 255, 255, 0.4), 8px 8px 24px rgba(9, 13, 20, 0.06);\n// }\n.faded-1-surface {\n  background: rgba(93, 45, 225, 0.06);\n  mix-blend-mode: normal;\n  border-radius: 12px;\n}\n.faded-2-surface {\n  background: rgba(60, 53, 210, 0.12);\n  mix-blend-mode: normal;\n  border-radius: 12px;\n}\n","@use \"/src/assets/stylesheets/shared/surface\";\n@use \"/src/assets/stylesheets/shared/typography\";\n@import \"/src/assets/stylesheets/variables\";\n\n.modal {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    height: 35%;\n    width: 20%;\n    max-width: 990px;\n    .titleContainer {\n        background-color: transparent;\n        display: flex;\n        align-items: center;\n        gap: 16px;\n    }\n    .header {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n\n        button {\n            position: absolute;\n            bottom: 0;\n        }\n    }\n    .toggleContainer {\n        display: flex;\n        width: 100%;\n        border-bottom: 1px solid rgba(20, 16, 41, 0.12);\n        border-radius: 1px 1px 0px 0px;\n        position: relative;\n        margin-bottom: 8px;\n    }\n    .active {\n        font-weight: $font-med;\n        font-family: $text-font-family-semi;\n    }\n    .notActive {\n        font-weight: $font-light;\n        font-family: $text-font-family-med;\n    }\n    .activeBorder {\n        height: 2px;\n        background-color: $primary-color;\n        position: absolute;\n        bottom: -1px;\n        transition: all 0.2s;\n    }\n    .container {\n        display: flex;\n        justify-content: space-between;\n        flex-wrap: wrap;\n        gap: 16px;\n        background-color: var(--bg-color);\n    }\n    .card {\n        background: rgba(235, 239, 245, 0.6);\n        border-radius: 24px;\n        padding: 20px 24px 24px;\n        display: flex;\n        flex-direction: column;\n        gap: 20px;\n        width: 100%;\n\n        h3 {\n            color: $dark-text-color;\n            font-weight: $font-med;\n            font-size: $font-size-xm;\n            line-height: $font-height-md;\n            font-family: $text-font-family-semi;\n        }\n        form {\n            display: flex;\n            flex-direction: column;\n            gap: 24px;\n        }\n        .rowForm {\n            display: flex;\n            flex-direction: row;\n            gap: 16px;\n            .colContainer {\n                display: flex;\n                flex-direction: column;\n                width: 100%;\n                max-width: 416px;\n\n                gap: 24px;\n            }\n            @media (max-width: 650px) {\n                flex-direction: column;\n            }\n        }\n\n        .inpContainer {\n            height: 48px;\n            width: 100%;\n        }\n    }\n    .halfWidth {\n        max-width: 440px;\n    }\n    .fullWidth {\n        max-width: 100%;\n    }\n    .switchContainer {\n        background: rgba(20, 16, 41, 0.03);\n        border-radius: 12px;\n        padding: 14px 12px;\n    }\n    .viewBtn {\n        position: absolute;\n        right: 12px;\n        top: 12px;\n        z-index: 3;\n    }\n    .infoContainer {\n        background: rgba(20, 16, 41, 0.03);\n        border-radius: 12px;\n        padding: 8px 12px;\n        span {\n            display: block;\n        }\n        .key {\n            color: $dark-text-color;\n            font-weight: $font-light;\n            font-size: 10px;\n            line-height: 12px;\n            font-family: $text-font-family-med;\n        }\n        .value {\n            color: $dark-text-color;\n            font-weight: $font-light;\n            font-size: $font-size-xs;\n            line-height: $font-height-xs;\n            font-family: $text-font-family-med;\n        }\n    }\n    .paymentContainer {\n        display: flex;\n        justify-content: space-between;\n        gap: 24px;\n        .cardInp {\n            width: 100%;\n            max-width: 272px;\n        }\n        .expInp {\n            width: 100%;\n            max-width: 96px;\n        }\n        .stateInp {\n            width: 100%;\n            max-width: 296px;\n        }\n        .number {\n            font-family: $number-font-family-med;\n        }\n    }\n    .btns {\n        width: 100%;\n        display: flex;\n        flex-wrap: wrap;\n        justify-content: space-between;\n        gap: 16px;\n        button {\n            max-width: 188px;\n            width: 100%;\n        }\n        .delete {\n            background-color: rgba(20, 16, 41, 0.03);\n            &:hover {\n                background-color: $dark-color;\n            }\n        }\n    }\n    .methodsContainer {\n        display: flex;\n        flex-direction: column;\n        height: 328px;\n        overflow: auto;\n        gap: 16px;\n    }\n    .methodContainer {\n        background: rgba(20, 16, 41, 0.03);\n        border-radius: 12px;\n        display: flex;\n        align-items: center;\n        gap: 12px;\n        padding: 12px;\n        cursor: pointer;\n        img {\n            width: 24px;\n        }\n        span {\n            color: $dark-text-color;\n            font-weight: $font-med;\n            font-size: $font-size-xs;\n            line-height: $font-height-xs;\n            font-family: $text-font-family-semi;\n        }\n    }\n    .activeMethod {\n        outline: solid 2px $primary-color;\n        outline-offset: -5px;\n    }\n    .largeTexts {\n        button {\n            font-size: 12px;\n        }\n    }\n    .addNew {\n        margin-left: auto;\n        @media (max-width: 650px) {\n            margin-left: initial;\n        }\n    }\n    .walletsContainer {\n        display: flex;\n        gap: 16px;\n        flex-wrap: wrap;\n        button {\n            background: rgba(20, 16, 41, 0.03);\n            border-radius: 12px;\n            padding: 10px;\n        }\n        img {\n            width: 36px;\n        }\n    }\n    .marginTopBtn {\n        margin-top: 88px;\n    }\n    @media (max-width: 550px) {\n        padding: 40px 16px 32px;\n        .titleContainer h2 {\n            font-size: $font-size-xl;\n            line-height: $font-height-xm;\n        }\n        .marginTopBtn {\n            margin-top: 0;\n        }\n    }\n}\n.methodsContainer::-webkit-scrollbar {\n    width: 12px;\n}\n\n.methodsContainer::-webkit-scrollbar-thumb {\n    border: 4px solid rgba(0, 0, 0, 0);\n    background-clip: padding-box;\n    border-radius: 9999px;\n    background-color: #aaaaaa;\n}\n\n.popup-surface {\n    position: fixed;\n    left: 72%;\n    transition: all 0.2s;\n    z-index: 10;\n    overflow: auto;\n    max-height: 87vh;\n    max-width: 100%;\n    transform: translateX(-50%);\n    border-radius: 12px;\n    @media (max-width: 550px) {\n        border-radius: 40px 40px 0px 0px;\n    }\n}\n\n.show {\n    animation: fadeIn 0.3s forwards;\n    @media (max-width: 550px) {\n        animation: resposiveFadeIn 0.3s forwards;\n    }\n}\n\n@keyframes fadeIn {\n    0% {\n        opacity: 0;\n        top: 4%;\n    }\n    50% {\n        opacity: 1;\n        top: 12%;\n    }\n    100% {\n        top: 10%;\n    }\n}\n@keyframes resposiveFadeIn {\n    0% {\n        opacity: 0;\n        bottom: -105%;\n    }\n    100% {\n        opacity: 1;\n        bottom: 0;\n    }\n}\n/* width */\n.popup-surface::-webkit-scrollbar {\n    width: 12px;\n}\n.popup-surface::-webkit-scrollbar-track {\n    margin: 30px 0;\n}\n\n.popup-surface::-webkit-scrollbar-thumb {\n    border: 4px solid rgba(0, 0, 0, 0);\n    background-clip: padding-box;\n    border-radius: 9999px;\n    background-color: #aaaaaa;\n}\n","// colors\n$primary-color: #5d2de1;\n$dark-color: #141029;\n$cultured-color: #f5f7fa;\n$dark-text-color: rgba(20, 16, 41, 0.8);\n$white-color: #ffffff;\n$card-gradient-color: linear-gradient(\n  135deg,\n  #ffffff 0%,\n  #fafbfc 51.82%,\n  #f5f7fa 100%\n);\n$pink-color: #e0e0ff;\n$white-color-40: rgba(255, 255, 255, 0.4);\n$white-color-4: rgba(224, 224, 255, 0.04);\n$danger-color: #f54562;\n\n// fonts\n\n$font-size-xs: 13px;\n$font-size-sm: 14px;\n$font-size-md: 16px;\n$font-size-xm: 18px;\n$font-size-lg: 20px;\n$font-size-xl: 24px;\n$font-size-xxl: 30px;\n$font-size-3xl: 36px;\n$font-size-4xl: 48px;\n\n$font-height-xs: 16px;\n$font-height-sm: 20px;\n$font-height-md: 24px;\n$font-height-xm: 28px;\n$font-height-lg: 30px;\n$font-height-xl: 32px;\n$font-height-xxl: 36px;\n$font-height-3xl: 40px;\n$font-height-4xl: 48px;\n\n$font-light: 500;\n$font-med: 600;\n$font-bold: 700;\n$font-extra: 800;\n\n@font-face {\n  font-family: \"bold-Poppins\";\n  src: url(/assets/fonts/Poppins-Bold.ttf);\n}\n@font-face {\n  font-family: \"bold-Montserrat\";\n  src: url(/assets/fonts/Montserrat-Bold.ttf);\n}\n@font-face {\n  font-family: \"semi-Poppins\";\n  src: url(/assets/fonts/Poppins-SemiBold.ttf);\n}\n@font-face {\n  font-family: \"semi-Montserrat\";\n  src: url(/assets/fonts/Montserrat-SemiBold.ttf);\n}\n@font-face {\n  font-family: \"med-Poppins\";\n  src: url(/assets/fonts/Poppins-Medium.ttf);\n}\n@font-face {\n  font-family: \"med-Montserrat\";\n  src: url(/assets/fonts/Montserrat-Medium.ttf);\n}\n@font-face {\n  font-family: \"bold-gilory\";\n  src: url(/assets/fonts/Gilroy-Bold.ttf);\n}\n@font-face {\n  font-family: \"extra-gilory\";\n  src: url(/assets/fonts/Gilroy-ExtraBold.otf);\n}\n@font-face {\n  font-family: \"semi-gilory\";\n  src: url(/assets/fonts/Montserrat-SemiBold.ttf);\n}\n@font-face {\n  font-family: \"med-gilory\";\n  src: url(/assets/fonts/Gilroy-Medium.ttf);\n}\n\n$title-font-family-bold: \"bold-Poppins\";\n$title-font-family-semi: \"semi-Poppins\";\n$title-font-family-med: \"med-Poppins\";\n$text-font-family-bold: \"bold-Montserrat\";\n$text-font-family-semi: \"semi-Montserrat\";\n$text-font-family-med: \"med-Montserrat\";\n$number-font-family-bold: \"bold-gilory\";\n$number-font-family-extra: \"extra-gilory\";\n$number-font-family-semi: \"semi-gilory\";\n$number-font-family-med: \"med-gilory\";\n\n// dark and light theme\n$dark-bg-color: #111315; // background\n$dark-sb-bg-color: #242527; // sidebar\n\n$light-bg-color: #F4F4F4; // background\n$light-sb-bg-color: #FCFCFC; // sidebar","@import \"../variables\";\n\n.sectionTitle {\n  color: $dark-text-color;\n  font-family: $title-font-family-bold;\n  font-weight: $font-bold;\n  font-size: $font-size-3xl;\n  line-height: $font-height-xxl;\n  position: relative;\n}\n.lightSectionTitle {\n  color: $white-color;\n  font-family: $title-font-family-bold;\n  font-weight: $font-bold;\n  font-size: $font-size-3xl;\n  line-height: $font-height-xxl;\n}\n.cardTitle {\n  color: $dark-text-color;\n  font-family: $text-font-family-semi;\n  font-weight: $font-med;\n  font-size: $font-size-md;\n  line-height: $font-height-md;\n  display: block;\n}\n.cardSubTitle {\n  color: $dark-text-color;\n  font-family: $text-font-family-med;\n  font-weight: $font-light;\n  font-size: $font-size-xs;\n  line-height: $font-height-xs;\n  display: block;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"primary-surface": `ModalTopUp_primary-surface__AnvIX`,
	"primary-bg": `ModalTopUp_primary-bg__Jpvrr`,
	"secondary-surface": `ModalTopUp_secondary-surface__bgbYF`,
	"faded-surface": `ModalTopUp_faded-surface__1Cri4`,
	"header-surface": `ModalTopUp_header-surface__Pwbnj`,
	"card-surface": `ModalTopUp_card-surface__VT7Ka`,
	"dropdown-surface": `ModalTopUp_dropdown-surface__xjeae`,
	"faded-1-surface": `ModalTopUp_faded-1-surface__gmSkt`,
	"faded-2-surface": `ModalTopUp_faded-2-surface__VlTmg`,
	"sectionTitle": `ModalTopUp_sectionTitle__3H2lj`,
	"lightSectionTitle": `ModalTopUp_lightSectionTitle__By06o`,
	"cardTitle": `ModalTopUp_cardTitle__EGpf1`,
	"cardSubTitle": `ModalTopUp_cardSubTitle__V-bPS`,
	"modal": `ModalTopUp_modal__YzSCF`,
	"titleContainer": `ModalTopUp_titleContainer__ZB8mx`,
	"header": `ModalTopUp_header__K-LkB`,
	"toggleContainer": `ModalTopUp_toggleContainer__yOL3w`,
	"active": `ModalTopUp_active__I2svQ`,
	"notActive": `ModalTopUp_notActive__dQzfv`,
	"activeBorder": `ModalTopUp_activeBorder__kG6pO`,
	"container": `ModalTopUp_container__66+Lm`,
	"card": `ModalTopUp_card__TBgho`,
	"rowForm": `ModalTopUp_rowForm__WCXBw`,
	"colContainer": `ModalTopUp_colContainer__VJ7Jl`,
	"inpContainer": `ModalTopUp_inpContainer__zuHGU`,
	"halfWidth": `ModalTopUp_halfWidth__VtOev`,
	"fullWidth": `ModalTopUp_fullWidth__IOvzJ`,
	"switchContainer": `ModalTopUp_switchContainer__Mvr-e`,
	"viewBtn": `ModalTopUp_viewBtn__tsc3+`,
	"infoContainer": `ModalTopUp_infoContainer__rGDJG`,
	"key": `ModalTopUp_key__YJgUD`,
	"value": `ModalTopUp_value__nnxJ+`,
	"paymentContainer": `ModalTopUp_paymentContainer__SCq5l`,
	"cardInp": `ModalTopUp_cardInp__6nrSA`,
	"expInp": `ModalTopUp_expInp__Lp9Wu`,
	"stateInp": `ModalTopUp_stateInp__4JDPQ`,
	"number": `ModalTopUp_number__XVOKQ`,
	"btns": `ModalTopUp_btns__Wm+D2`,
	"delete": `ModalTopUp_delete__PdlYm`,
	"methodsContainer": `ModalTopUp_methodsContainer__6hJl4`,
	"methodContainer": `ModalTopUp_methodContainer__ekFyQ`,
	"activeMethod": `ModalTopUp_activeMethod__5SFsx`,
	"largeTexts": `ModalTopUp_largeTexts__FjxSW`,
	"addNew": `ModalTopUp_addNew__8bcPx`,
	"walletsContainer": `ModalTopUp_walletsContainer__etvXQ`,
	"marginTopBtn": `ModalTopUp_marginTopBtn__V48iJ`,
	"popup-surface": `ModalTopUp_popup-surface__x9-Fy`,
	"show": `ModalTopUp_show__oWC-y`,
	"fadeIn": `ModalTopUp_fadeIn__AzNWx`,
	"resposiveFadeIn": `ModalTopUp_resposiveFadeIn__qVS6C`
};
export default ___CSS_LOADER_EXPORT___;
